//Belongs to HiringContract Entity
export const ComplaintStatusEnum = Object.freeze({
  Pending: 0,
  Resolved: 1,
});

export const ComplaintStatusLabel = Object.freeze({
  [ComplaintStatusEnum.Pending]: "Pending",
  [ComplaintStatusEnum.Resolved]: "Resolved",
});
